import React from "react";

const OccupancyChartSkeleton: React.FC = () => {
    return (
        <div className="mt-4 p-3 bg-white rounded shadow-sm">
            <h5 className="text-center mb-3">
                Occupancy Percentage (Last 12 Months)
            </h5>
            <div style={{ height: "400px" }} className="d-flex justify-content-center align-items-center">
                <div className="spinner-border text-primary" role="status">
                    <span className="visually-hidden">Loading...</span>
                </div>
            </div>
        </div>
    );
};

export default OccupancyChartSkeleton;
